import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { capitalize, isArray } from 'lodash';
import { UKCountryList } from '../../constants/quote';
import { QuotePlatformSourceEnum } from '../../enums/quote';
import { getBrokerEntityApprovalStatusMap, getBrokerEntityPlatformMap } from '../../localeConstants';
import { PromotionEntityType, SubBrokerType } from '../../shared/generated';
import { isPublishOnline } from '../common';
import { getLocalTranslation } from '../i18nKit';
export var judgeIsPromotionQuote = function judgeIsPromotionQuote(promotionInfo) {
  var _ref = promotionInfo || {},
      promotionType = _ref.promotionType;

  return [PromotionEntityType.PARTNER_PROMOTION, PromotionEntityType.BROKER_PROMOTION].includes(promotionType);
};
export var judgeIsSubPromotionQuote = function judgeIsSubPromotionQuote(promotionInfo) {
  var _ref2 = promotionInfo || {},
      subBrokerType = _ref2.subBrokerType;

  return judgeIsPromotionQuote(promotionInfo) && !!subBrokerType;
};
export var judgeIsPartnerPromotionQuote = function judgeIsPartnerPromotionQuote(promotionInfo) {
  var _ref3 = promotionInfo || {},
      promotionType = _ref3.promotionType,
      subBrokerType = _ref3.subBrokerType;

  return [PromotionEntityType.PARTNER_PROMOTION].includes(promotionType) || subBrokerType === SubBrokerType.PARTNER;
};
export var judgeIsBrokerPromotionQuote = function judgeIsBrokerPromotionQuote(promotionInfo) {
  var _ref4 = promotionInfo || {},
      promotionType = _ref4.promotionType,
      subBrokerType = _ref4.subBrokerType;

  return [PromotionEntityType.BROKER_PROMOTION].includes(promotionType) && subBrokerType !== SubBrokerType.PARTNER || subBrokerType === SubBrokerType.BROKER;
};
export var judgeIsMainPartnerQuote = function judgeIsMainPartnerQuote(promotionInfo) {
  var _ref5 = promotionInfo || {},
      promotionType = _ref5.promotionType,
      subBrokerType = _ref5.subBrokerType;

  return [PromotionEntityType.PARTNER_PROMOTION].includes(promotionType) && !subBrokerType;
};
export var judgeIsMainBrokerQuote = function judgeIsMainBrokerQuote(promotionInfo) {
  var _ref6 = promotionInfo || {},
      promotionType = _ref6.promotionType,
      subBrokerType = _ref6.subBrokerType;

  return [PromotionEntityType.BROKER_PROMOTION].includes(promotionType) && !subBrokerType;
};
export var judgeIsSubPartnerQuote = function judgeIsSubPartnerQuote(promotionInfo) {
  var _ref7 = promotionInfo || {},
      subBrokerType = _ref7.subBrokerType;

  return subBrokerType === SubBrokerType.PARTNER;
}; // Payment methods switch

export var getQuoteDisabledPaymentMethods = function getQuoteDisabledPaymentMethods(promotionInfo, config) {
  var _promotionInfo, _promotionInfo$paymen;

  return (promotionInfo === null || promotionInfo === void 0 ? void 0 : (_promotionInfo = promotionInfo[(config === null || config === void 0 ? void 0 : config.payloadKey) || 'payload']) === null || _promotionInfo === void 0 ? void 0 : (_promotionInfo$paymen = _promotionInfo.payment_settings) === null || _promotionInfo$paymen === void 0 ? void 0 : _promotionInfo$paymen.disabled_payment_methods) || [];
};
/**
 * Quote header branding configured on the broker/partner branding page in CMS.
 * It is stored on the partner level (`payload.quote_process_settings`), so it is read back
 * through `partnerPayload` of the promotion info instead of the product level `payload`.
 * `logoUrl` is the resolved icon to render: the one configured by the broker wins, and it falls
 * back to the company logo carried by the same promotion info, so callers never repeat that.
 * `logoHeight` is normalised to a css length so it can be applied to a style directly.
 */

export var getQuoteHeaderBrandingInfo = function getQuoteHeaderBrandingInfo(promotionInfo, config) {
  var _promotionInfo2, _promotionInfo$logo;

  var _ref8 = (promotionInfo === null || promotionInfo === void 0 ? void 0 : (_promotionInfo2 = promotionInfo[(config === null || config === void 0 ? void 0 : config.payloadKey) || 'partnerPayload']) === null || _promotionInfo2 === void 0 ? void 0 : _promotionInfo2.quote_process_settings) || {},
      quote_header_logo_url = _ref8.quote_header_logo_url,
      quote_header_background_color = _ref8.quote_header_background_color,
      quote_header_logo_height = _ref8.quote_header_logo_height;

  return {
    logoUrl: quote_header_logo_url || (promotionInfo === null || promotionInfo === void 0 ? void 0 : (_promotionInfo$logo = promotionInfo.logo) === null || _promotionInfo$logo === void 0 ? void 0 : _promotionInfo$logo.url) || '',
    backgroundColor: quote_header_background_color || '',
    logoHeight: formatQuoteHeaderLogoHeight(quote_header_logo_height)
  };
};

var formatQuoteHeaderLogoHeight = function formatQuoteHeaderLogoHeight(height) {
  if (!height && height !== 0) {
    return '';
  }

  return typeof height === 'number' || /^\d+(\.\d+)?$/.test("".concat(height)) ? "".concat(height, "px") : "".concat(height);
};

export var judgeCanHandlePartnerQuote = function judgeCanHandlePartnerQuote(config) {
  var promotionInfo = config.promotionInfo,
      tripartiteInfo = config.tripartiteInfo,
      platformSourceType = config.platformSourceType;
  return !(judgeIsSubUserVisitPartnerQuote({
    promotionInfo: promotionInfo,
    platformSourceType: platformSourceType,
    tripartiteInfo: tripartiteInfo
  }) || judgeIsMainPartnerQuote(promotionInfo) && platformSourceType === QuotePlatformSourceEnum.portal);
};
export var getBrokerDetailPageUrl = function getBrokerDetailPageUrl(promotionInfo, tab) {
  var _ref9 = promotionInfo || {},
      partnerSlug = _ref9.partnerSlug;

  if (!partnerSlug) return '';
  return "/brokers/".concat(partnerSlug, "/detail?tab=").concat(tab, "&hideBack=true");
};
export var getQuoteRelatedUserAndPromotionInformationList = function getQuoteRelatedUserAndPromotionInformationList(promotionInfo, config) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var _ref10 = promotionInfo || {},
      promotionType = _ref10.promotionType,
      partnerName = _ref10.partnerName,
      memberFirstName = _ref10.memberFirstName,
      memberLastName = _ref10.memberLastName,
      memberEmail = _ref10.memberEmail,
      memberPhone = _ref10.memberPhone,
      name = _ref10.name,
      brokerEntities = _ref10.brokerEntities;

  var _ref11 = config || {},
      source = _ref11.source,
      fullName = _ref11.fullName;

  var isPartnerQuote = judgeIsPartnerPromotionQuote(promotionInfo);
  var quotesDetailUrl = getBrokerDetailPageUrl(promotionInfo, 'quotes');
  var productSettingsDetailUrl = getBrokerDetailPageUrl(promotionInfo, 'productSettings');
  var onboardingInformationDetailUrl = getBrokerDetailPageUrl(promotionInfo, 'onboardingInformation');
  var list = [];
  var managerList = isPublishOnline() ? [] : [{
    title: 'Origination manager',
    content: ''
  }, {
    title: 'Activation manager',
    content: ''
  }];

  if (isPartnerQuote) {
    list.push.apply(list, [_objectSpread({
      title: $t('page:partners.partner_name'),
      content: partnerName || ''
    }, quotesDetailUrl ? {
      type: 'link',
      linkUrl: quotesDetailUrl
    } : {}), _objectSpread({
      title: $t('page:partners.partner_product'),
      content: name || ''
    }, productSettingsDetailUrl ? {
      type: 'link',
      linkUrl: productSettingsDetailUrl
    } : {})]);
    list.push.apply(list, managerList);
    list.push.apply(list, [{
      title: $t('page:partners.partner_member_name'),
      content: memberFirstName ? "".concat(memberFirstName, " ").concat(memberLastName) : ''
    }, {
      title: $t('page:partners.partner_member_email'),
      content: memberEmail || ''
    }, {
      title: $t('page:partners.partner_member_phone'),
      content: memberPhone || ''
    }]);
  } else {
    if (promotionType === PromotionEntityType.BROKER_PROMOTION) {
      list.push.apply(list, [{
        title: $t('page:brokers.quote_platform'),
        content: !!source ? capitalize(source) : 'Direct',
        contentClassName: 'text-brand-secondary'
      }, _objectSpread({
        title: $t('page:successContact.broker_name_label'),
        content: partnerName || ''
      }, quotesDetailUrl ? {
        type: 'link',
        linkUrl: quotesDetailUrl
      } : {}), _objectSpread({
        title: $t('page:brokers.broker_product'),
        content: name || ''
      }, productSettingsDetailUrl ? {
        type: 'link',
        linkUrl: productSettingsDetailUrl
      } : {})]); // Broker entity information

      if ((brokerEntities === null || brokerEntities === void 0 ? void 0 : brokerEntities.length) > 0) {
        var entityName = [];
        var scidCode = [];
        var approveStatusList = [];
        brokerEntities.forEach(function (item) {
          if (item.name) {
            entityName.push(item.name);
            approveStatusList.push(!!item.is_approved ? getBrokerEntityApprovalStatusMap().approved.label : getBrokerEntityApprovalStatusMap().notApproved.label);
          }

          if (UKCountryList.includes(item.country_code) && item.platform === getBrokerEntityPlatformMap().acturis.value && item.broker_registration_id) {
            scidCode.push(item.broker_registration_id);
          }
        });

        if (entityName.length > 0) {
          list.push(_objectSpread({
            title: $t('page:brokers.broker_entity_name'),
            content: entityName.join(', ')
          }, onboardingInformationDetailUrl ? {
            type: 'link',
            linkUrl: onboardingInformationDetailUrl
          } : {}));
        }

        if (approveStatusList.length > 0) {
          list.push({
            title: 'broker entity status',
            content: approveStatusList.join(', ')
          });
        }

        if (scidCode.length > 0) {
          list.push({
            title: 'SCID Code',
            content: scidCode.join(', ')
          });
        }
      }

      list.push.apply(list, managerList);
      list.push.apply(list, [{
        title: $t('page:brokers.broker_member_name'),
        content: memberFirstName ? "".concat(memberFirstName, " ").concat(memberLastName) : ''
      }, {
        title: $t('page:brokers.broker_member_email'),
        content: memberEmail || ''
      }, {
        title: $t('page:brokers.broker_member_phone'),
        content: memberPhone || ''
      }]);
    } else {
      list.push({
        title: $t('page:brokers.customer_name'),
        content: fullName,
        contentClassName: 'text-brand-secondary'
      });
    }
  }

  return list;
};
export var judgeIsSubUserVisitPartnerQuote = function judgeIsSubUserVisitPartnerQuote(config) {
  var _ref12 = config || {},
      promotionInfo = _ref12.promotionInfo,
      tripartiteInfo = _ref12.tripartiteInfo,
      platformSourceType = _ref12.platformSourceType;

  var _ref13 = promotionInfo || {},
      subBrokerType = _ref13.subBrokerType;

  var _ref14 = tripartiteInfo || {},
      parent_id = _ref14.parent_id;

  return subBrokerType === SubBrokerType.PARTNER && platformSourceType === QuotePlatformSourceEnum.portal && !!parent_id;
};
export var judgeLegalEntitySkipSetCommission = function judgeLegalEntitySkipSetCommission(promotionInfo) {
  if (isArray(promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.brokerEntities) && (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.brokerEntities.length) > 0) {
    var _promotionInfo$broker, _promotionInfo$broker2, _promotionInfo$broker3;

    return !!(promotionInfo !== null && promotionInfo !== void 0 && (_promotionInfo$broker = promotionInfo.brokerEntities) !== null && _promotionInfo$broker !== void 0 && (_promotionInfo$broker2 = _promotionInfo$broker[0]) !== null && _promotionInfo$broker2 !== void 0 && (_promotionInfo$broker3 = _promotionInfo$broker2.payload) !== null && _promotionInfo$broker3 !== void 0 && _promotionInfo$broker3.skip_set_commission);
  } else {
    return false;
  }
};
export var judgeBrokerProductIsEmptyCommission = function judgeBrokerProductIsEmptyCommission(promotionInfo) {
  if (isArray(promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.brokerEntities) && (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.brokerEntities.length) > 0) {
    var _promotionInfo$broker4, _promotionInfo$broker5, _promotionInfo$broker6;

    if (!!(promotionInfo !== null && promotionInfo !== void 0 && (_promotionInfo$broker4 = promotionInfo.brokerEntities) !== null && _promotionInfo$broker4 !== void 0 && (_promotionInfo$broker5 = _promotionInfo$broker4[0]) !== null && _promotionInfo$broker5 !== void 0 && (_promotionInfo$broker6 = _promotionInfo$broker5.payload) !== null && _promotionInfo$broker6 !== void 0 && _promotionInfo$broker6.skip_set_commission)) {
      return true;
    }
  }

  if (Number((promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.promotionBrokerCommissionFee) || 0) <= 0) {
    return true;
  }

  return false;
};
export var judgeIsJoveDirectSaleQuote = function judgeIsJoveDirectSaleQuote(quoteDetailInfo) {
  var _ref15 = quoteDetailInfo || {},
      promotionId = _ref15.promotionId;

  return !promotionId;
};
export var judgeIsWholesaleBrokerQuote = function judgeIsWholesaleBrokerQuote(quoteDetailInfo) {
  var _brokerFeeChain$;

  var _ref16 = quoteDetailInfo || {},
      promotionId = _ref16.promotionId,
      brokerFeeChain = _ref16.brokerFeeChain;

  return !!promotionId && (!brokerFeeChain || (brokerFeeChain === null || brokerFeeChain === void 0 ? void 0 : (_brokerFeeChain$ = brokerFeeChain[0]) === null || _brokerFeeChain$ === void 0 ? void 0 : _brokerFeeChain$.promotion_id) === promotionId);
};